module.exports = __webpack_public_path__ + "static/media/akanshu.f734df1a.jpg";